<div style="min-height: 5rem;"><!-- minima altura para mostrar el messagebar -->
    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>

    <app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage" [closeable]="false"></app-frms-messagebar>
    <div *ngIf="showMap">
        <app-db-superv-overview #supervmapdashboard [site]="site" [supervision]="supervision" [dbSupervOverview_options]="dbSupervOverview_options"
            [chartcontainerwidth]="'chart-container-width-25'"></app-db-superv-overview>
    </div>
</div>